export default __webpack_public_path__ + "static/media/deepali.a435778d.jpeg";